import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  return <section id="pricing" className="bg-gradient-to-b from-stone-900 to-stone-950 text-stone-50 py-24 px-4 relative overflow-hidden" data-id="element-104">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(217,119,6,0.2)_0,transparent_70%)] pointer-events-none" data-id="element-105" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-106">
        <FadeIn data-id="element-107">
          <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight" data-id="element-108">
            Recupera tu agilidad hoy mismo
          </h2>
          <p className="text-xl md:text-2xl text-stone-300 mb-12 max-w-2xl mx-auto" data-id="element-109">
            Por una fracción de lo que cuesta una sola consulta médica o una
            caja de antiinflamatorios de marca. Acceso inmediato a la guía
            completa "Despertar Sin Dolor".
          </p>

          <div className="bg-stone-900 border-2 border-amber-600/50 rounded-3xl p-8 md:p-12 shadow-2xl shadow-amber-900/20 max-w-2xl mx-auto" data-id="element-110">
            <div className="mb-8" data-id="element-111">
              <div className="flex items-center justify-center gap-4 mb-1" data-id="element-112">
                <span className="text-3xl md:text-4xl font-bold text-stone-500 line-through" data-id="element-113">
                  $19
                </span>
                <span className="bg-red-600 text-white text-sm md:text-base font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-114">
                  -66% OFF
                </span>
              </div>
              <span className="text-6xl md:text-7xl font-black text-amber-500" data-id="element-115">
                $6.39
              </span>
              <span className="text-2xl text-stone-400 font-medium ml-2" data-id="element-116">
                USD
              </span>
              <p className="text-stone-500 mt-2 font-medium uppercase tracking-widest text-sm" data-id="element-117">
                (Pago único)
              </p>
            </div>

            <Button fullWidth className="mb-6 py-5 text-2xl" onClick={() => {
            trackAddToCart();
            window.open('https://guiasparavivir.com/cart/52440554701089:1', '_blank');
          }} data-id="element-118">
              ¡Sí! Quiero Despertar Sin Dolor
            </Button>

            <p className="text-stone-300 text-lg font-medium flex items-center justify-center gap-2" data-id="element-119">
              <ShieldCheck className="w-5 h-5 text-amber-500" data-id="element-120" />
              Acceso instantáneo para empezar mañana mismo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}